import './index.scss'
var oTable = $('table');
if (oTable.length !== 0) {
    var oTr = oTable.find('tr'),
        oTd = oTable.find('td');

    oTable.wrap("<div class='table-box'></div>");
    oTr.attr('style', '');
    if (oTable.find("td[style='text-align: center']").length !== 0) {
        oTd.attr('style', '');
        oTd.css({
            'text-align': 'center',
        });
    } else {
        oTd.attr('style', '');
    }
}

$(".product-nav dl dt").click(function() {
    $(this).parent().toggleClass("active");
    $(this).parent().find(".dd").stop().slideToggle();
})
